module.exports = __webpack_public_path__ + "static/media/notice.33a91da0.jpeg";